var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:_vm.$style.labelValueRow},[_c('span',[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }